import { Divider } from "@material-ui/core";
import {  withStyles } from "@material-ui/styles";

export const StyledDivider = withStyles({
  root: {
    margin: "15px 0",
    width: "100%",
    background: "#ABAFB3",
  },
})(Divider);